import { Component } from '@angular/core';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ProjectsSettings } from 'src/app/enums/settings';

@Component({
    selector: 'app-setari-proiecte',
    templateUrl: './setari-proiecte.component.html',
    styleUrls: ['./setari-proiecte.component.scss']
})
export class SetariProiecteComponent {
    readonly ProjectsSettings = ProjectsSettings;
    selectedComponent!: ProjectsSettings;

    componentMapping: Record<ProjectsSettings, string> = {
        [ProjectsSettings.CATEGORII_PROIECTE]: 'app-categorii-proiecte',
        [ProjectsSettings.SECTIUNI_PROIECTE]: 'app-sectiuni-proiecte',
        [ProjectsSettings.STATUSURI_PROIECTE]: 'app-statusuri-proiecte',
        [ProjectsSettings.TAGURI_PROIECTE]: 'app-taguri-proiecte',
        [ProjectsSettings.FURNIZORI_PROIECTE]: 'app-furnizori-proiecte',
        [ProjectsSettings.AGENTI_PROIECTE]: 'app-agenti-proiecte',
        [ProjectsSettings.MOTIVE_DELAY_PROIECTE]: 'app-motive-proiecte',
        [ProjectsSettings.OPERATORI_PROIECTE]: 'app-motive-proiecte',
    };
    componentKeys: string[] = Object.keys(this.componentMapping);

    onChange($event: { value: any }) {
        this.selectedComponent = $event.value;
    }

    selectedSection: any = null;

    constructor(private permissionsService: PermissionsService) {
        this.filterComponents();
    }

    filterComponents() {
        if (
            !this.permissionsService.hasPermission(
                'monitoring-module.proiecte.categorii.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== ProjectsSettings.CATEGORII_PROIECTE
            );
        }
        if (
            !this.permissionsService.hasPermission(
                'monitoring-module.proiecte.sectiuni.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== ProjectsSettings.SECTIUNI_PROIECTE
            );
        }
        if (
            !this.permissionsService.hasPermission(
                'monitoring-module.proiecte.tag.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== ProjectsSettings.TAGURI_PROIECTE
            );
        }
        if (
            !this.permissionsService.hasPermission(
                'monitoring-module.proiecte.provider.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== ProjectsSettings.FURNIZORI_PROIECTE
            );
        }
        if (
            !this.permissionsService.hasPermission(
                'monitoring-module.proiecte.agent.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== ProjectsSettings.AGENTI_PROIECTE
            );
        }
        if (
            !this.permissionsService.hasPermission(
                'monitoring-module.proiecte.motiv-delay.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== ProjectsSettings.MOTIVE_DELAY_PROIECTE
            );
        }
        if (
            !this.permissionsService.hasPermission(
                'monitoring-module.proiecte.proiecte-status.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== ProjectsSettings.STATUSURI_PROIECTE
            );
        }
        // if (
        //     !this.permissionsService.hasPermission(
        //         'monitoring-module.proiecte.proiecte-status.list'
        //     )
        // ) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== ProjectsSettings.OPERATORI_PROIECTE
        //     );
        // }
    }
}
